export default __webpack_public_path__ + "static/media/javascript.fd46ca41.svg";